import { call, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
  ADD_NEW_MAYBANK_APPOINTMENTS,
  ADD_REMARKS_PRE_APPOINTMENTS,
  CONFIRM_MAYBANK_APPOINTMENTS,
  DELETE_MAYBANK_APPOINTMENTS,
  GET_MAYBANK_APPOINTMENTS,
  GET_MAYBANK_APPOINTMENTS_DETAILS,
  UPDATE_MAYBANK_APPOINTMENTS,
} from "./actionTypes.js";

import {
  addMaybankAppointmentsFail,
  addMaybankAppointmentsSuccess,
  addRemakrsPreAppointmentsFail,
  addRemakrsPreAppointmentsSuccess,
  confirmMaybankAppointmentsFail,
  confirmMaybankAppointmentsSuccess,
  deleteMaybankAppointmentsFail,
  deleteMaybankAppointmentsSuccess,
  getMaybankAppointmentsDetailsFail,
  getMaybankAppointmentsDetailsSuccess,
  getMaybankAppointmentsFail,
  getMaybankAppointmentsSuccess,
  updateMaybankAppointmentsFail,
  updateMaybankAppointmentsSuccess,
} from "./actions.js";

import {
  addNewMaybankAppointments,
  addRemarksPreEmploymentAppointment,
  confirmAppointment,
  delMaybankAppointments,
  maybankAppointmentsDetailsApi,
  maybankAppointmentsListingApi,
  updateMaybankAppointments
} from "./maybankApi.js";

function* fetchMaybankAppointments({ payload: length, sort, page, name, appointment_at, status, sort_by }) {
  try {
    const response = yield call(maybankAppointmentsListingApi, length, sort, page, name, appointment_at, status, sort_by)
    yield put(getMaybankAppointmentsSuccess(response))
  } catch (error) {
    yield put(getMaybankAppointmentsFail(error))
  }
}
function* fetchMaybankAppointmentsDetails({ payload: id }) {
  try {
    const response = yield call(maybankAppointmentsDetailsApi, id)
    yield put(getMaybankAppointmentsDetailsSuccess(response))
  } catch (error) {
    yield put(getMaybankAppointmentsDetailsFail(error))
  }
}

function* onAddNewMaybankAppointments({ payload: maybankAppointments }) {
  try {
    const response = yield call(addNewMaybankAppointments, maybankAppointments)
    yield put(addMaybankAppointmentsSuccess(response))
  } catch (error) {
    yield put(addMaybankAppointmentsFail(error))
  }
}

function* onUpdateMaybankAppointments({ payload: id, maybankAppointments }) {
  try {
    const response = yield call(updateMaybankAppointments, id, maybankAppointments)
    yield put(updateMaybankAppointmentsSuccess(response))
  } catch (error) {
    yield put(updateMaybankAppointmentsFail(error))
  }
}

function* onDelMaybankAppointments({ payload: { id, data } }) {
  try {
    const response = yield call(delMaybankAppointments, id, data)
    yield put(deleteMaybankAppointmentsSuccess(response))
  } catch (error) {
    yield put(deleteMaybankAppointmentsFail(error))
  }
}

function* onConfirmMaybankAppointments({ payload: id,maybankAppointments }) {
  try {
    const response = yield call(confirmAppointment, id, maybankAppointments)
    yield put(confirmMaybankAppointmentsSuccess(response))
  } catch (error) {
    yield put(confirmMaybankAppointmentsFail(error))
  }
}


function* onAddRemarksAppointment({ payload}) {
  try {
    const response = yield call(addRemarksPreEmploymentAppointment, payload)
    yield put(addRemakrsPreAppointmentsSuccess(response))
  } catch (error) {
    yield put(addRemakrsPreAppointmentsFail(error))
  }
}

function* MaybankAppointmentsSaga() {

  yield takeEvery(GET_MAYBANK_APPOINTMENTS, fetchMaybankAppointments)
  yield takeEvery(GET_MAYBANK_APPOINTMENTS_DETAILS, fetchMaybankAppointmentsDetails)
  yield takeEvery(ADD_NEW_MAYBANK_APPOINTMENTS, onAddNewMaybankAppointments)
  yield takeEvery(UPDATE_MAYBANK_APPOINTMENTS, onUpdateMaybankAppointments)
  yield takeEvery(DELETE_MAYBANK_APPOINTMENTS, onDelMaybankAppointments)
  yield takeEvery(CONFIRM_MAYBANK_APPOINTMENTS, onConfirmMaybankAppointments)
  yield takeEvery(ADD_REMARKS_PRE_APPOINTMENTS, onAddRemarksAppointment)
}

export default MaybankAppointmentsSaga
